{
  "id": "zeus",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Zeus",
    "en": "Zeus"
  },
  "icon": "gods/zeus",
  "portrait": "gods/zeus-portrait",
  "modifiers": [
    {
      "target": "favorRate",
      "op": "pct",
      "value": 0.2,
      "note": "Villagers gather favor 20% faster (Gather WorkRate on AbstractTemple x1.20 BasePercent).",
      "scope": {
        "ids": ["temple"]
      }
    },
    {
      "target": "pop",
      "op": "add",
      "value": -1,
      "scope": {
        "tags": ["myth"]
      },
      "note": "Myth units cost 1 less population (PopulationCount -1 Absolute on MythUnit)."
    }
  ],
  "startExtras": {
    "resources": {
      "favor": 10
    }
  },
  "powers": ["bolt"],
  "minors": {
    "classical": ["athena", "hermes"],
    "heroic": ["apollo", "dionysus"],
    "mythic": ["hera", "hephaestus"]
  },
  "unlocks": ["myrmidon", "jason", "heracles", "odysseus", "bellerophon", "olympian-parentage"],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Also (not modelled): infantry +0.60 HandAttack damage bonus vs buildings, Hoplites x1.15 speed. Starts with 10 favor (startExtras)."
  }
}
